import React from 'react';
import ErrorNotification from '../../../../ErrorNotification';
import {ServerNotificationProps} from '../../../ServerNotification';
import {INotificationProps} from '@src/@interfaces/components/Notifications/INotificationProps';
import app from '@src/helpers/app';
import makeUrl from '@src/components/Notifications/server-notifications/makeUrl';
import getDashboardEndpoint from '@src/components/Notifications/server-notifications/Order/getDashboardEndpoint';

export default class CannotFindOwnerOfFile extends ErrorNotification<
        ServerNotificationProps<'App\\Notifications\\Order\\Product\\File\\CannotFindOwnerOfFile'> &
        INotificationProps
> {
    protected getWrapperTagProps(): any {
        const payload = this.props.notification.data;
        const namesResolver = app('names-resolver').clientRoutes;

        return {
            ...super.getWrapperTagProps(),
            to: makeUrl({
                uriItems: [
                    getDashboardEndpoint('manager-order-page', payload.context.orderId),
                    {
                        route: namesResolver.getShowRouteName(payload.context.controllerName),
                        params: {id: String(payload.context.orderId)},
                    }
                ],
                searchParams: {productCode: payload.context.productCode},
                hash: '#OrdersShow.tabs.products',
            }),
        };
    }

    protected getDescriptionReplacements() {
        return {
            ...this.props.notification.data.context,
            ...this.props.notification.data.clientFileMetadata,
            name: <span>{this.props.notification.data.clientFileMetadata.name}</span>,
        };
    }
}
